import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { Value } from 'app/types-shared';
import { BowtieCase } from '../types';
import { ConnectedCasesState } from '../types-store';
import { getConnectionsFromCase } from './map-draft-connections';

export const mapConnectedToCases = (
  connectionToCaseNumber: number,
  connectionType: number,
  connectedCases: ConnectedCasesState,
  draft: BowtieCase
): BowtieCase[] => {

  const connected = isDefinedIncludingZero(connectionType) &&
    connectedCases?.connected?.[connectionToCaseNumber]?.[connectionType]?.length
    ? connectedCases.connected[connectionToCaseNumber][connectionType]
    : [];

  const otherConnections = connected
    .filter(connectedCase => connectedCase.caseId !== draft?.caseNumber)
    .map(
      connectedCase => {

        const { caseId: caseNumber, fields } = connectedCase;

        return {
          primaryKey: undefined,
          caseNumber,
          caseType: fields?.CaseType ? (fields.CaseType as Value) : undefined,
          fields: Object.keys(fields).reduce(
            (result, key) => ({
              ...result,
              [key]: Array.isArray(fields[key])
                ? { values: fields[key] }
                : { values: [fields[key]] }
            }), {})
        };
      }
    );

  const connectionsFromDraft = getConnectionsFromCase(draft, connectionToCaseNumber);
  const hasConnectionToDraft = connectionsFromDraft.some(connection => connection.value === connectionType);

  return hasConnectionToDraft
    ? [
      ...otherConnections,
      draft
    ]
    : otherConnections;
};
